<template>
  <button
    :class="['cf-header__cart-button', { 'cf-header__cart-button--has-items': orderItemCountForUser > 0 }]"
    type="button"
    title="View Cart"
    @click="cartClickHandler"
  >
    <div class="cart-button-icon">
      <span class="cf-icon far fa-shopping-bag" />

      <transition name="cart-icon">
        <span
          v-if="orderItemCountForUser > 0"
          :key="orderItemCountForUser"
          :class="['cart-count', { 'cart-count--order-at-table': isOrderAtTable }]"
        >
          {{ orderItemCountForUser }}
        </span>
      </transition>
    </div>

    <cf-background-overlay
      v-if="isNavigatingToOrderSummary"
      :with-loader="true"
    />
  </button>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CartMixin from '@/view/vue/mixins/cart-mixin/index.vue';

  import CfBackgroundOverlay from '@/view/components/shared/cf-background-overlay/index.vue';


  export default {
    name: 'CfCartButton',

    components: {
      CfBackgroundOverlay
    },

    mixins: [CartMixin],

    computed: {
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),
      ...mapGetters('orders', ['order', 'orderItemCountForUser', 'upsellItems']),
      ...mapGetters('session', ['applicationFlow', 'currentUser', 'orderDetails', 'session']),
      ...mapGetters('locations', ['selectedLocation']),

      isOrderAtTable() {
        return this.applicationFlow === 'orderAtTable';
      },

      cartItemQuantity() {
        let total = 0;

        this.order.orderItems.forEach((orderItem) => {
          if (orderItem.units) {
            total += orderItem.quantity * orderItem.units;
          }
          else {
            total += orderItem.quantity;
          }
        });

        return total;
      },

      hasCartItems() {
        return this.cartItemQuantity > 0;
      },

      isUpsellModalEnabled() {
        return (this.order.upsellDisplayMode === 'Modal' || this.order.upsellDisplayMode === 'ModalCategory') && this.upsellItems.checkoutUpsellItems.length > 0;
      },

      hasNoUpsellTargetAmounts() {
        return this.order.upsellRules?.every(upsellRule => !upsellRule.targetAmount);
      },

      hasMetUpsellTargetAmount() {
        return this.order.upsellRules?.find(upsellRule => upsellRule.targetAmount === this.cartItemQuantity);
      },

      hasExceededUpsellTargetAmounts() {
        return this.order.upsellRules?.every(upsellRule => upsellRule.targetAmount <= this.cartItemQuantity);
      },

      hasMetUpsellModalTrigger() {
        const upsellItem = this.order.upsellRules?.find(upsellRule => !!upsellRule.triggerAmount);

        return this.cartItemQuantity >= upsellItem?.triggerAmount;
      }
    },

    methods: {
      cartClickHandler() {
        const isOrderAheadAtTable = this.session.orderDetails.fulfillmentType === 'dine-in';
        const hasTableNumber = !!this.session.route.tableNumber;
        const isTableNumberRequired = this.selectedLocation.features.RequireTableSelectionForOrdering;

        if (this.isUpsellModalEnabled && (this.hasNoUpsellTargetAmounts || (this.hasMetUpsellModalTrigger && !this.hasMetUpsellTargetAmount && !this.hasExceededUpsellTargetAmounts))) {
          this.$openModal('upsellModal');
        }
        else if (isOrderAheadAtTable && !hasTableNumber && isTableNumberRequired) {
          this.$openModal('enterTableNumberModal');
        }
        else {
          /** CartMixin method */
          this.openCartPage();
        }
      }
    }
  };
</script>
